import React from "react"
import Links from "../constants/links"
import SocialLinks from "../constants/socialLinks"
import { FaTimes } from "react-icons/fa"
import PropTypes from "prop-types"
const Sidebar = ({ isOpened = false, toggleSideBar }) => {
  return (
    <aside className={`sidebar ${isOpened ? "show-sidebar" : ""}`}>
      <button className="close-btn" onClick={toggleSideBar}>
        <FaTimes />
      </button>
      <div className="">
        <Links styleClass={`${isOpened ? "sidebar-links" : ""}`} />
        <SocialLinks styleClass={`${isOpened ? "sidebar-icons" : ""}`} />
      </div>
    </aside>
  )
}
Sidebar.prototype = {
  isOpened: PropTypes.boolean,
}

export default Sidebar
